module.exports = __webpack_public_path__ + "img/tokyu-vacations-bg-mobile.0f51458c.png";